const dateFilter = (time, type) => {
    if(!time) return;
    let d = new Date(), y, m, day, h, min, s;
    time = time * 1000;
    d.setTime(time);
    y = d.getFullYear();
    m = d.getMonth() + 1 > 9 ? d.getMonth() + 1 : '0' + (d.getMonth() + 1);
    day = d.getDate() > 9 ? d.getDate() : '0' + d.getDate();
    h = d.getHours() > 9 ? d.getHours() : '0' + d.getHours();
    min = d.getMinutes() > 9 ? d.getMinutes() : '0' + d.getMinutes();
    s = d.getSeconds() > 9 ? d.getSeconds() : '0' + d.getSeconds();
    switch(type)
    {
        case 'yy-mm-dd hh:mm':
            return y + '-' + m + '-' + day + ' ' + h + ':' + min;
        default:
            //年月日
            return y + '年' + m + '月' + day + '日 ' + h + '时' + min + '分';
    }
}

const  timeFormatting = function(timeDate, category) {
    // timeDate 时间戳 category 需要的格式
    let date = new Date(parseInt(timeDate)*1000);
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var seconds = date.getSeconds();
    if (month >= 1 && month <= 9) {
        month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
    }
    if (hours >= 0 && hours <= 9) {
        hours = "0" + hours;
    }
    if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
    }
    if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
    }
    switch (category) {
    case "y":
        date = year + "-" + month + "-" + strDate;
        break;
    case "yh":
        date = year + "年" + month + "月" + strDate + "日" + hours + "时";
        break;
    case "yhdm":
        date = year + "-" + month + "-" + strDate + " " + hours + ":" + minutes;
        break;
    case "yhdm-ch":
        date = year + "年" + month + "月" + strDate + "日 " + hours + ":" + minutes;
        break;
    case "yhdms":
        date = year + "年" + month + "月" + strDate + "日 " + hours + ":" + minutes + ":" + seconds;
        break;
    case "yd":
        date = year + "年" + month + "月" + strDate + "日";
        break;
    case "day":
        date = month + "月" + strDate + "日";
        break;
    case "hdm":
        date = strDate + "天" + hours + "时" + minutes + "分";
        break;
    default:
        date = month + "月" + strDate + "日" + hours + "时";
    }
    return date;
}

export default { dateFilter,timeFormatting }


// WEBPACK FOOTER //
// ./src/js/lib/filters.js